<script setup>
import { inject, onMounted, onUnmounted, ref, watch } from 'vue';
import { useState } from "../hooks/useState";

const choices = {
    from: 'FROM',
    to: 'TO'
}

const placemarkOptions = {
    iconLayout: 'default#imageWithContent',
    iconImageHref: '',
    iconImageSize: [36, 36],
    iconImageOffset: [-18, -18],
    iconContentOffset: [18, 18],

}

const { items } = defineProps(['items'])
const [isActive, setIsActive] = useState(true)
const [isСhoice, setIsСhoice] = useState(false)
const [from, setFrom] = useState(false)
const [to, setTo] = useState(false)
const [placemarks, setPlaceMarks] = useState([])
const [map, setMap] = useState(null)


const window = inject('window')
const mapTarget = ref(null)

const bounds = [
    [45.042710693155826, 39.03501183158023],
    [45.044907458081916, 39.039619030711954]
]

const ymaps = window.ymaps
let route


function load() {
    console.log('load');
    ymaps.ready(init)
}

function init() {
    const map = new ymaps.Map(mapTarget.value, {
        bounds: bounds,
        controls: [],
        behaviors: [],
    }, { avoidFractionalZoom: false })

    setMap(map)

    renderOverlay(map)
    renderPlaceMarks(map)

}

function renderPlaceMarks(map) {
    // if (!map) {
    //     return
    // }

    // placemarks.value.forEach((placemark) => {
    //     map.geoObjects.remove(placemark);
    // })

    const newPlacemarks = []

    items.forEach((item) => {
        const placeMarkContent = ymaps.templateLayoutFactory.createClass(
            `<div class="map-marker">
                <img src="${window.ASSETS_DIR}img/markers/${item.category.key || item.category}.png" alt="">
            </div>`)

        const placeMarkContentHover = ymaps.templateLayoutFactory.createClass(
            `<div class="map-marker hover">
                <img src="${window.ASSETS_DIR}img/markers/${item.category.key || item.category}.png" alt="">
            </div>`)

        const placemark = new ymaps.Placemark(item.mapsCoords, {}, {
            ...placemarkOptions,
            iconContentLayout: placeMarkContent
        });

        placemark.events.add('click', () => placemarkClickHandler(item))

        placemark.events.add('mouseenter', () => {
            placemark.options.set('iconContentLayout', placeMarkContentHover)
        })

        placemark.events.add('mouseleave', () => {
            placemark.options.set('iconContentLayout', placeMarkContent)
        })

        newPlacemarks.push(placemark)
        map.geoObjects.add(placemark);
    });

    setPlaceMarks(newPlacemarks)

}

function placemarkClickHandler(item) {
    if (isСhoice.value === choices.from) {
        setFrom(item)
        setIsСhoice(false)
        return
    }
    if (isСhoice.value === choices.to) {
        setTo(item)
        setIsСhoice(false)
        return
    }

    if (!from.value) {
        setFrom(item)
        return
    }

    if (!to.value) {
        setFrom(item)
        return
    }
}

function renderOverlay(map) {
    const overlay = new ymaps.Rectangle(bounds, {}, {
        fillImageHref: '/img/map-for-path.jpg',
        outline: false,
        cursor: 'default'
    })
    map.geoObjects.add(overlay);
}

function renderRoute({ from, to, map }) {
    // map.geoObjects.remove(route);
    route = new ymaps.multiRouter.MultiRoute({
        referencePoints: [from, to],
        params: { routingMode: 'pedestrian' }
    }, {
        boundsAutoApply: false,
        routeStrokeWidth: 4,
        routeStrokeColor: "#ffffff",
        routeActiveStrokeWidth: 6,
        // routeActivePedestrianSegmentStrokeStyle: "solid",
    });
    map.geoObjects.add(route);
}

function showClickHandler(event) {
    console.log('showClickHandler');
    setIsActive(true)
}

watch(mapTarget, (value, oldValue) => {
    if (value && !oldValue) {
        load()
    }
})

</script>

<template>
    <div class="path map-path" v-if="isActive">
        <div class="path-contorls" :class="isСhoice ? 'choice-active' : ''">
            <div class="text-h4 mb-10">Построить маршрут</div>
            <!-- Откуда -->
            <div class="form-field mb-4" @click="setIsСhoice(choices.from)">
                <div class="form-input-cover">
                    <div class="form-input flex flex-align-center">
                        <img :src="`${window.ASSETS_DIR}img/compass.png`" alt="" class="mr-2">
                        <div class="fade-60" v-if="!from">Откуда</div>
                        <div class="" v-else>{{ from.title }}</div>
                    </div>
                </div>
            </div>
            <!-- Куда -->
            <div class="form-field mb-4">
                <div class="form-input-cover" @click="setIsСhoice(choices.to)">
                    <div class="form-input flex flex-align-center">
                        <img :src="`${window.ASSETS_DIR}img/compass.png`" alt="" class="mr-2">
                        <div class="fade-60" v-if="!to">Куда</div>
                        <div class="" v-else>{{ to.title }}</div>
                    </div>
                </div>
            </div>

            <button class="btn btn--fill btn--sec w-100 btn-large mt-8" v-if="from && to" @click="renderRoute({
                from: from.mapCoords,
                to: to.mapCoords,
                map: map
            })">
                Проложить маршрут
            </button>

        </div>
        <div class="path-maps-map" ref="mapTarget"></div>
    </div>
    <button class="map-path-btn btn btn--white-bg" v-else @click="showClickHandler">
        <svg class="icon text-h4 mr-2">
            <use :xlink:href="`${window.ASSETS_DIR}img/icons.svg#path`" />
        </svg>
        Проложить маршрут
    </button>
</template>